import { render, staticRenderFns } from "./DefiDepositConfirmation.vue?vue&type=template&id=7aa66487&"
import script from "./DefiDepositConfirmation.vue?vue&type=script&lang=js&"
export * from "./DefiDepositConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports